import React from "react";
import "./LaunchNow.css";
import usePageMeta from "../../hooks/usePageMeta";

export default function LaunchNow() {
  usePageMeta();
  return (
    <>
      <p>launch</p>
    </>
  );
}
